import {
  FormTemplateFieldTypes,
  SelectFormFieldOptions,
} from 'mapistry-shared';
import React from 'react';
import { EditableFormTemplateField } from '../../../types';
import { ConditionalBoolField } from './ConditionalBoolField';
import { ConditionalDateField } from './ConditionalDateField';
import { ConditionalNumberField } from './ConditionalNumberField';
import { ConditionalSelectField } from './ConditionalSelectField';
import { ConditionalTextField } from './ConditionalTextField';
import { ConditionalTimeField } from './ConditionalTimeField';

export interface ConditionalFieldValueInputProps {
  triggerField: EditableFormTemplateField;
  rulePrefix: string;
  inputFieldProps: {
    name: string;
    label: string;
    placeholder: string;
    error?: boolean;
    errorText?: string;
  };
}

export function ConditionalFieldValueFactory({
  triggerField,
  rulePrefix,
  inputFieldProps,
}: ConditionalFieldValueInputProps) {
  switch (triggerField.type) {
    case FormTemplateFieldTypes.BOOLEAN:
      return <ConditionalBoolField {...inputFieldProps} />;
    case FormTemplateFieldTypes.NUMBER:
      return <ConditionalNumberField {...inputFieldProps} />;
    case FormTemplateFieldTypes.DATE:
      return <ConditionalDateField {...inputFieldProps} />;
    case FormTemplateFieldTypes.TIME:
      return <ConditionalTimeField {...inputFieldProps} />;
    case FormTemplateFieldTypes.SINGLE_SELECT:
    case FormTemplateFieldTypes.SINGLE_SELECT_WITH_FREE_FORM:
    case FormTemplateFieldTypes.MULTI_SELECT:
    case FormTemplateFieldTypes.MULTI_SELECT_WITH_FREE_FORM:
      return (
        <ConditionalSelectField
          options={triggerField.options as SelectFormFieldOptions}
          rulePrefix={rulePrefix}
          inputFieldProps={inputFieldProps}
        />
      );
    case FormTemplateFieldTypes.TEXT:
    case FormTemplateFieldTypes.TEXT_AREA:
    case FormTemplateFieldTypes.WEATHER:
    case FormTemplateFieldTypes.PHONE_NUMBER:
    default:
      return <ConditionalTextField {...inputFieldProps} />;
  }
}
